"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComplexDeliveryDatabase = exports.isComplexDeliveryInput = exports.isComplexDelivery = void 0;
const isComplexDelivery = (delivery) => {
    const complexDelivery = delivery;
    return complexDelivery.places && complexDelivery.places.length > 0;
};
exports.isComplexDelivery = isComplexDelivery;
const isComplexDeliveryInput = (deliveryInput) => {
    const complexDeliveryInput = deliveryInput;
    return complexDeliveryInput.places && complexDeliveryInput.places.length > 0;
};
exports.isComplexDeliveryInput = isComplexDeliveryInput;
const isComplexDeliveryDatabase = (deliveryInput) => {
    const complexDeliveryInput = deliveryInput;
    return complexDeliveryInput.places && complexDeliveryInput.places.length > 0;
};
exports.isComplexDeliveryDatabase = isComplexDeliveryDatabase;
